import gsap from 'gsap';
import Dispatch from '../core/Dispatch';
import { COMPONENT_INIT } from '../lib/events';

export default el => {

    const text = el.querySelector('[data-text]');
    let hasEventListeners = false;

    const onMouseEnter = () => {
        gsap.fromTo(text, {
            height: text.getBoundingClientRect().height
        }, {
            height: 'auto',
            duration: 0.3
        });
        el.classList.add('active');
    };

    const onMouseLeave = () => {
        gsap.to(text, {
            height: 0,
            duration: 0.3
        });
        el.classList.remove('active');
    };

    const init = () => {
        if (!CSS.supports('interpolate-size', 'allow-keywords')) {
            el.addEventListener('mouseenter', onMouseEnter);
            el.addEventListener('mouseleave', onMouseLeave);
            el.addEventListener('focusin', onMouseEnter);
            el.addEventListener('focusout', onMouseLeave);
            text.classList.remove('transition-all', 'group-hocus-within:h-auto');
            text.classList.add('transition-colors');
            hasEventListeners = true;
        }

        Dispatch.emit(COMPONENT_INIT);
    };

    const destroy = () => {
        if (hasEventListeners) {
            el.addEventListener('mouseenter', onMouseEnter);
            el.addEventListener('mouseleave', onMouseLeave);
            el.addEventListener('focusin', onMouseEnter);
            el.addEventListener('focusout', onMouseEnter);
        }
    };

    return {
        init,
        destroy
    };

};
